export function haandleJwtInLocalStorage(param) {
    try {
        param.token && localStorage.setItem('jwt', param.token);
    } catch (error) {
        console.log(error);
    }
   
}